import { render, staticRenderFns } from "./RouteBuilderUndeliverableOrderCard.vue?vue&type=template&id=6cb4a072&"
import script from "./RouteBuilderUndeliverableOrderCard.vue?vue&type=script&lang=js&"
export * from "./RouteBuilderUndeliverableOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./RouteBuilderUndeliverableOrderCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports